import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ModalDialog, Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { Field, reduxForm, getFormValues } from "redux-form";
import LocaleStrings from "Languages";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import ReportissueModalList from "./modallist-item";
import { classNames, COMMON_FAIL_MESSAGE } from "Constants";
import AppIcons from "AppIcons";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  uploadreportedAttachments,
  addReports_tracker,
  fetchadminissueTokenOpen,
  fetchadminissueTokenClose,
  updateissueStatus,
  fetchsingleReport,
  updateReports_tracker,
  sendnewsupportTicketetointernal,
  closeIssueemail,
} from "AccountSettingsAction";

var Loader = require("react-loaders").Loader; // import "AwesomeLoaderCss";

class ReportIssueModal extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      btnLoading: false,
      btnsendclosedisabled: false,
      btnsendcloseLoading: false,
      fileArr: [],
      btncloseloading: false,
      desc: "Preparing reports",
      replybox: false,
      btndisabled: false,
      notupdatedFormSubmit: false,
    };
  }

  componentDidMount() {
    this.props.fetchsingleReport(
      this.props.session,
      this.props.data?.id,
      (callback) => {
        this.setState({ loading: false });
      }
    );
  }

  closeModals = (senttoclose) => {
    if (senttoclose != "close") {
      this.handleDraft();
    }
    this.setState({ fileArr: [], replybox: false });
    this.props.onClose();
  };

  renderList() {
    let { singleReportdata } = this.props;
    let sortedDesc = _.orderBy(
      singleReportdata[0]?.support_ticket_messages_by_reportissueidfk,
      ["createdon"],
      ["desc"]
    );
    let sortedDesc1 = _.filter(sortedDesc, (obj, index) => {
      return obj.isdraft == true && obj.repliedby !== null;
    });

    if (sortedDesc1.length > 0) {
      let objWithIdIndex = sortedDesc.findIndex(
        (obj) => obj.id === sortedDesc1[0]?.id
      );
      if (objWithIdIndex > -1) {
        sortedDesc.splice(objWithIdIndex, 1);
      }
    }

    return _.map(sortedDesc, (values, index) => {
      return (
        <ReportissueModalList
          index={index}
          values={values}
          position={index}
          data={this.props.data}
        />
      );
    });
  }

  handleDraft = (e) => {
    let description = "";
    let { session, data, singleReportdata, initialValues, formValues, user } =
      this.props;

    let singlereportid = singleReportdata[0].id;
    let clientid = user.clientid;

    if (
      formValues != undefined &&
      formValues.description &&
      formValues.description != "" &&
      formValues.description != null
    ) {
      description = formValues.description;
    }
    // this.setState({ loading: true })
    if (description !== "") {
      // if (description !== '' && description.length > 2) {
      let attachmentNames = [];
      let uploaderCounter = 0;
      let filetobeupload = [];
      let arrPromise = [];
      if (this.state.fileArr.length > 0) {
        // console.log(1);
        _.forEach(this.state.fileArr, function (value, index) {
          let currentUnixTimestamp = Date.now();
          let ext = value.name.split(".").pop();
          let value_attachment_name =
            "attachment_" + currentUnixTimestamp + "_" + index + "." + ext;
          let replaced_attachementnames = `clients/${clientid}/supportticket/${value_attachment_name}`;
          attachmentNames.push(replaced_attachementnames);
          // attachmentNames.push(
          //   // `eventify/supportticket/${value.name}`
          //   `clients/${clientid}/supportticket/${value.name}`
          // );

          let coverJson = {
            type: value.type,
            name: replaced_attachementnames,
            media: value.url,
          };

          filetobeupload.push(coverJson);
        });

        let counter = filetobeupload.length;

        filetobeupload.map((item, index) => {
          arrPromise.push(
            new Promise((resolve, reject) => {
              this.props.uploadreportedAttachments(
                this.props.session,
                item,
                clientid,
                (response) => {
                  if (response.success === 0) {
                    resolve();
                  } else {
                    uploaderCounter++;
                    resolve();
                  }
                }
              );
            })
          );
        });

        let attachments = _.join(attachmentNames, ",");
        var data2 = {
          reportissueidfk: singleReportdata[0].id,
          repliedby: user.clientid,
          description: description,
          attachments: attachments,
          isdraft: 1,
        };
        if (Object.keys(initialValues).length > 0) {
          data2.id = initialValues.id;
          this.props.updateReports_tracker(session, data2, (response) => {
            if (response.success === 0) {
              this.setState({ btnLoading: false });
              // alert("error");
              this.props.showError(COMMON_FAIL_MESSAGE);
            } else {
              this.props.fetchadminissueTokenOpen(
                this.props.session,
                clientid,
                (CallBackResponse) => {
                  this.props.fetchadminissueTokenClose(
                    this.props.session,
                    clientid,
                    (CallBackResponse) => {
                      this.props.fetchsingleReport(
                        session,
                        singlereportid,
                        (callback) => {
                          if (this.state.btnLoading == true) {
                            this.props.reset();
                          }
                          this.setState({ fileArr: [] });
                          this.setState({ loading: false });
                          this.setState({ btnLoading: false });
                          this.props.showSuccess("Successfully Sent");
                        }
                      );

                      // this.closeModal();
                    }
                  );
                }
              );
            }
          });
        } else {
          this.props.addReports_tracker(session, data2, (response) => {
            if (response.success === 0) {
              this.setState({ btnLoading: false });
              // alert("error");
              this.props.showError(COMMON_FAIL_MESSAGE);
            } else {
              this.props.fetchadminissueTokenOpen(
                this.props.session,
                clientid,
                (CallBackResponse) => {
                  this.props.fetchadminissueTokenClose(
                    this.props.session,
                    clientid,
                    (CallBackResponse) => {
                      this.props.fetchsingleReport(
                        session,
                        singlereportid,
                        (callback) => {
                          this.props.reset();
                          this.setState({ fileArr: [] });
                          this.setState({ loading: false });
                          this.setState({ btnLoading: false });
                          this.props.showSuccess("Successfully Sent");
                        }
                      );
                    }
                  );
                }
              );
            }
          });
        }
      } else {
        var data2 = {
          reportissueidfk: singleReportdata[0].id,
          repliedby: user.clientid,
          description: description,
          isdraft: 1,
        };

        if (Object.keys(initialValues).length > 0) {
          data2.id = initialValues.id;

          this.props.updateReports_tracker(session, data2, (response) => {
            if (response.success === 0) {
              this.setState({ btndisabled: false });
              this.props.showError(COMMON_FAIL_MESSAGE);
            } else {
              this.props.fetchadminissueTokenOpen(
                this.props.session,
                clientid,
                (CallBackResponse) => {
                  this.props.fetchadminissueTokenClose(
                    this.props.session,
                    clientid,
                    (CallBackResponse) => {
                      this.props.fetchsingleReport(
                        session,
                        singlereportid,
                        (callback) => {
                          this.props.reset();
                          this.setState({ btndisabled: false });
                          this.setState({ btnLoading: false });
                          this.setState({ loading: false });
                        }
                      );
                    }
                  );
                }
              );
            }
          });
        } else {
          this.props.addReports_tracker(session, data2, (response) => {
            if (response.success === 0) {
              this.setState({ loading: false });
              this.props.showError(COMMON_FAIL_MESSAGE);
            } else {
              this.props.fetchadminissueTokenOpen(
                this.props.session,
                clientid,
                (CallBackResponse) => {
                  this.props.fetchadminissueTokenClose(
                    this.props.session,
                    clientid,
                    (CallBackResponse) => {
                      this.props.fetchsingleReport(
                        session,
                        singlereportid,
                        (callback) => {
                          this.props.reset();
                          this.setState({ btndisabled: false });
                          this.setState({ btnLoading: false });
                          this.setState({ loading: false });
                        }
                      );
                    }
                  );
                }
              );
            }
          });
        }
      }
    }
  };

  onSubmitForm = (values) => {
    let { session, data, singleReportdata, initialValues, user } = this.props;
    this.setState({ notupdatedFormSubmit: true });

    let singlereportid = singleReportdata[0].id;
    let clientid = user.clientid;
    let attachmentNames = [];
    let uploaderCounter = 0;
    let filetobeupload = [];
    let arrPromise = [];
    let obj = {
      id: singlereportid,
    };

    if (
      !values.hasOwnProperty("description") ||
      values.description.trim() == "" ||
      values.description == null
    ) {
      this.props.showError(
        LocaleStrings.accountsetting_reportissuemodal_nodesc_error
      );
      return false;
    }
    this.setState({ btnLoading: true });
    let sendnewticketEmailtointernalobj = {};
    sendnewticketEmailtointernalobj.id = singlereportid;
    sendnewticketEmailtointernalobj.type = "sendnewsupportTicketetointernal";
    sendnewticketEmailtointernalobj.clientid = user.clientid;
    sendnewticketEmailtointernalobj.newticket = 0;

    if (singleReportdata[0].status == "closed") {
      obj.status = "open";
    }

    if (this.state.fileArr.length > 0) {
      _.forEach(this.state.fileArr, function (value, index) {
        let currentUnixTimestamp = Date.now();
        let ext = value.name.split(".").pop();
        let value_attachment_name =
          "attachment_" + currentUnixTimestamp + "_" + index + "." + ext;
        let replaced_attachementnames = `clients/${clientid}/supportticket/${value_attachment_name}`;
        attachmentNames.push(replaced_attachementnames);
        // attachmentNames.push(
        //   // `eventify/supportticket/${value.name}`
        //   `clients/${clientid}/supportticket/${value.name}`
        // );

        let coverJson = {
          type: value.type,
          name: replaced_attachementnames,
          media: value.url,
        };

        filetobeupload.push(coverJson);
      });

      let counter = filetobeupload.length;

      filetobeupload.map((item, index) => {
        arrPromise.push(
          new Promise((resolve, reject) => {
            this.props.uploadreportedAttachments(
              this.props.session,
              item,
              clientid,
              (response) => {
                if (response.success === 0) {
                  resolve();
                } else {
                  uploaderCounter++;
                  resolve();
                }
              }
            );
          })
        );
      });

      let attachments = _.join(attachmentNames, ",");
      var data2 = {
        reportissueidfk: singleReportdata[0].id,
        repliedby: user.clientid,
        description: values.description,
        attachments: attachments,
        isdraft: 0,
      };
      if (Object.keys(initialValues).length > 0) {
        data2.id = initialValues.id;

        this.props.updateReports_tracker(session, data2, (response) => {
          if (response.success === 0) {
            this.setState({ btnLoading: false });
            // alert("error");
            this.props.showError(COMMON_FAIL_MESSAGE);
          } else {
            this.props.updateissueStatus(session, obj, (response) => {});
            this.props.sendnewsupportTicketetointernal(
              session,
              sendnewticketEmailtointernalobj,
              (response) => {}
            );
            this.props.fetchadminissueTokenOpen(
              this.props.session,
              clientid,
              (CallBackResponse) => {
                this.props.fetchadminissueTokenClose(
                  this.props.session,
                  clientid,
                  (CallBackResponse) => {
                    this.props.fetchsingleReport(
                      session,
                      singlereportid,
                      (callback) => {
                        this.props.reset();
                        this.setState({ fileArr: [] });
                        this.setState({ loading: false });
                        this.setState({ btnLoading: false });
                        this.props.showSuccess(
                          LocaleStrings.accountsetting_reportissuemodal_sent_success
                        );
                      }
                    );

                    // this.closeModal();
                  }
                );
              }
            );
          }
        });
      } else {
        this.props.addReports_tracker(session, data2, (response) => {
          if (response.success === 0) {
            this.setState({ btnLoading: false });
            // alert("error");
            this.props.showError(COMMON_FAIL_MESSAGE);
          } else {
            this.props.updateissueStatus(session, obj, (response) => {});
            this.props.sendnewsupportTicketetointernal(
              session,
              sendnewticketEmailtointernalobj,
              (response) => {}
            );
            this.props.fetchadminissueTokenOpen(
              this.props.session,
              clientid,
              (CallBackResponse) => {
                this.props.fetchadminissueTokenClose(
                  this.props.session,
                  clientid,
                  (CallBackResponse) => {
                    this.props.fetchsingleReport(
                      session,
                      singlereportid,
                      (callback) => {
                        this.props.reset();
                        this.setState({ fileArr: [] });
                        this.setState({ loading: false });
                        this.setState({ btnLoading: false });
                        this.props.showSuccess(
                          LocaleStrings.accountsetting_reportissuemodal_sent_success
                        );
                      }
                    );
                  }
                );
              }
            );
          }
        });
      }
    } else {
      var data2 = {
        reportissueidfk: singleReportdata[0].id,
        repliedby: user.clientid,
        description: values.description,
        isdraft: 0,
      };

      if (Object.keys(initialValues).length > 0) {
        data2.id = initialValues.id;
        this.props.updateReports_tracker(session, data2, (response) => {
          if (response.success === 0) {
            this.setState({ btndisabled: false });
            this.props.showError(COMMON_FAIL_MESSAGE);
          } else {
            this.props.updateissueStatus(session, obj, (response) => {});
            this.props.sendnewsupportTicketetointernal(
              session,
              sendnewticketEmailtointernalobj,
              (response) => {}
            );
            this.props.fetchadminissueTokenOpen(
              this.props.session,
              clientid,
              (CallBackResponse) => {
                this.props.fetchadminissueTokenClose(
                  this.props.session,
                  clientid,
                  (CallBackResponse) => {
                    this.props.fetchsingleReport(
                      session,
                      singlereportid,
                      (callback) => {
                        this.props.reset();
                        this.setState({ btndisabled: false });
                        this.setState({ btnLoading: false });
                        this.setState({ loading: false });
                      }
                    );
                  }
                );
              }
            );
          }
        });
      } else {
        this.props.addReports_tracker(session, data2, (response) => {
          // console.log("response", response);
          if (response.success === 0) {
            this.setState({ loading: false });
            this.props.showError(COMMON_FAIL_MESSAGE);
          } else {
            this.props.updateissueStatus(session, obj, (response) => {});
            this.props.sendnewsupportTicketetointernal(
              session,
              sendnewticketEmailtointernalobj,
              (response) => {}
            );
            this.props.fetchadminissueTokenOpen(
              this.props.session,
              clientid,
              (CallBackResponse) => {
                this.props.fetchadminissueTokenClose(
                  this.props.session,
                  clientid,
                  (CallBackResponse) => {
                    this.props.fetchsingleReport(
                      session,
                      singlereportid,
                      (callback) => {
                        this.props.reset();
                        this.setState({ btndisabled: false });
                        this.setState({ btnLoading: false });
                        this.setState({ loading: false });
                        // this.props.dispatch(change("ReportIssueModalForm", "description", ""));
                      }
                    );
                  }
                );
              }
            );
          }
        });
      }
    }
  };

  _handlsendClose = (e) => {
    let description = "";
    let { session, data, singleReportdata, initialValues, formValues } =
      this.props;
    let { sendcloseState } = this.state;
    if (
      formValues != undefined &&
      formValues.description &&
      formValues.description != "" &&
      formValues.description != null
    ) {
      description = formValues.description;
    }

    let clientid = singleReportdata[0].clientidfk;
    let singlereportid = singleReportdata[0].id;

    if (description != "" && description == null) {
      this.setState({ btnsendcloseLoading: true });
      this.setState({ btnsendclosedisabled: true });
      let attachmentNames = [];
      let uploaderCounter = 0;
      let filetobeupload = [];
      let arrPromise = [];
      // this.setState({ loading: true });

      if (this.state.fileArr.length > 0) {
        _.forEach(this.state.fileArr, function (value, index) {
          let currentUnixTimestamp = Date.now();
          let ext = value.name.split(".").pop();
          let value_attachment_name =
            "attachment_" + currentUnixTimestamp + "_" + index + "." + ext;
          let replaced_attachementnames = `clients/${clientid}/supportticket/${value_attachment_name}`;
          attachmentNames.push(replaced_attachementnames);
          // attachmentNames.push(
          //   `clients/${singleReportdata[0].clientidfk}/supportticket/${value.name}`
          // );

          let coverJson = {
            type: value.type,
            name: replaced_attachementnames,
            media: value.url,
          };

          filetobeupload.push(coverJson);
        });

        let counter = filetobeupload.length;

        filetobeupload.map((item, index) => {
          arrPromise.push(
            new Promise((resolve, reject) => {
              this.props.uploadreportedAttachments(
                this.props.session,
                item,
                singleReportdata[0].clientidfk,
                (response) => {
                  if (response.success === 0) {
                    resolve();
                  } else {
                    uploaderCounter++;
                    resolve();
                  }
                }
              );
            })
          );
        });

        let attachments = _.join(attachmentNames, ",");
        var data2 = {
          reportissueidfk: singleReportdata[0].id,
          description: description,
          attachments: attachments,
          isdraft: 0,
          repliedby: this.props.user.clientid,
        };
        // console.log("data21", data2);
        debugger;
        if (Object.keys(initialValues).length > 0) {
          data2.id = initialValues.id;
          this.props.updateReports_tracker(session, data2, (response) => {
            if (response.success === 0) {
              this.setState({ btnsendcloseLoading: false });
              this.setState({ btnsendclosedisabled: false });
              // alert("error");
              this.props.showError(COMMON_FAIL_MESSAGE);
            } else {
              let obj = {
                id: singleReportdata[0].id,
                status: "closed",
              };

              this.props.updateissueStatus(session, obj, (response) => {
                this.props.fetchadminissueTokenOpen(
                  this.props.session,
                  clientid,
                  (CallBackResponse) => {
                    this.props.fetchadminissueTokenClose(
                      this.props.session,
                      clientid,
                      (CallBackResponse) => {
                        this.props.fetchadminissueRepliedandTokenOpen(
                          this.props.session,
                          clientid,
                          (CallBackResponse) => {
                            this.props.fetchsingleReport(
                              session,
                              singlereportid,
                              (callback) => {
                                this.props.reset();
                                this.setState({ fileArr: [] });
                                this.setState({ btnsendcloseLoading: false });
                                this.setState({ btnsendclosedisabled: false });
                                this.props.showSuccess(
                                  LocaleStrings.accountsetting_reportissuemodal_sent_n_close_success
                                );
                                this.closeModals("close");
                              }
                            );
                          }
                        );

                        // this.closeModal();
                      }
                    );
                  }
                );
              });
            }
          });
        } else {
          let obj = {
            id: singleReportdata[0].id,
            status: "closed",
          };
          // console.log("data22", data2);
          // debugger;
          this.props.addReports_tracker(session, data2, (response) => {
            if (response.success === 0) {
              this.setState({ btnsendcloseLoading: false });
              this.setState({ btnsendclosedisabled: false });
              // alert("error");
              this.props.showError(COMMON_FAIL_MESSAGE);
            } else {
              this.props.updateissueStatus(session, obj, (response) => {
                this.props.fetchadminissueTokenOpen(
                  this.props.session,
                  clientid,
                  (CallBackResponse) => {
                    this.props.fetchadminissueTokenClose(
                      this.props.session,
                      clientid,
                      (CallBackResponse) => {
                        this.props.fetchadminissueRepliedandTokenOpen(
                          this.props.session,
                          clientid,
                          (CallBackResponse) => {
                            this.props.fetchsingleReport(
                              session,
                              singlereportid,
                              (callback) => {
                                this.props.reset();
                                this.setState({ btnsendcloseLoading: false });
                                this.setState({ btnsendclosedisabled: false });
                                this.setState({ fileArr: [] });
                                this.props.showSuccess(
                                  LocaleStrings.accountsetting_reportissuemodal_sent_n_close_success
                                );
                                this.closeModals("close");
                              }
                            );
                          }
                        );

                        // this.closeModal();
                      }
                    );
                  }
                );
              });
            }
          });
        }
      } else {
        var data2 = {
          reportissueidfk: singleReportdata[0].id,
          repliedby: this.props.user.clientid,
          description: description,
          isdraft: 0,
        };
        let obj = {
          id: singleReportdata[0].id,
          status: "closed",
        };

        if (Object.keys(initialValues).length > 0) {
          data2.id = initialValues.id;
          this.props.updateReports_tracker(session, data2, (response) => {
            if (response.success === 0) {
              this.setState({ btnsendcloseLoading: false });
              this.setState({ btnsendclosedisabled: false });
              this.props.showError(COMMON_FAIL_MESSAGE);
            } else {
              this.props.updateissueStatus(session, obj, (response) => {
                this.props.fetchadminissueTokenOpen(
                  this.props.session,
                  clientid,
                  (CallBackResponse) => {
                    this.props.fetchadminissueTokenClose(
                      this.props.session,
                      clientid,
                      (CallBackResponse) => {
                        this.props.fetchadminissueRepliedandTokenOpen(
                          this.props.session,
                          clientid,
                          (CallBackResponse) => {
                            this.props.fetchsingleReport(
                              session,
                              singlereportid,
                              (callback) => {
                                this.props.reset();
                                this.setState({ btnsendcloseLoading: false });
                                this.setState({ btnsendclosedisabled: false });
                                this.setState({ loading: false });
                                this.closeModals("close");
                              }
                            );
                          }
                        );
                      }
                    );
                  }
                );
              });
            }
          });
        } else {
          let obj = {
            id: singleReportdata[0].id,
            status: "closed",
          };
          // console.log("data24", data2);
          debugger;
          this.props.addReports_tracker(session, data2, (response) => {
            if (response.success === 0) {
              this.setState({ loading: false });
              this.props.showError(COMMON_FAIL_MESSAGE);
            } else {
              this.props.updateissueStatus(session, obj, (response) => {
                this.props.fetchadminissueTokenOpen(
                  this.props.session,
                  clientid,
                  (CallBackResponse) => {
                    this.props.fetchadminissueTokenClose(
                      this.props.session,
                      clientid,
                      (CallBackResponse) => {
                        this.props.fetchadminissueRepliedandTokenOpen(
                          this.props.session,
                          clientid,
                          (CallBackResponse) => {
                            this.props.fetchsingleReport(
                              session,
                              singlereportid,
                              (callback) => {
                                this.props.reset();
                                this.setState({ btnsendcloseLoading: false });
                                this.setState({ btnsendclosedisabled: false });
                                this.setState({ loading: false });
                                this.closeModals("close");
                                // this.props.dispatch(change("ReportIssueModalForm", "description", ""));
                                // NotificationManager.success('Successfully Sent');
                              }
                            );
                          }
                        );
                      }
                    );
                  }
                );
              });
            }
          });
        }
      }
    }
  };

  handlereplybox = (e, i) => {
    if (this.state.replybox == false) {
      this.setState({ replybox: true });
    } else {
      this.setState({ replybox: false });
    }
  };
  _handleUnSelect = (e, i) => {
    var attachmentDeleteItem = this.state.fileArr;
    attachmentDeleteItem.splice(i, 1); // first element removed
    this.setState({ fileArr: attachmentDeleteItem });
    this.props.change(this.props.pristine, false);
  };

  _handleSelect(event) {
    let { fileArr } = this.state;
    if (fileArr.length > 4) {
      this.props.showError(
        LocaleStrings.accountsetting_reportissuemodal_upto5files_error
      );
      return false;
    }
    const reader = new FileReader(); // Define reader
    let file = event.target.files[0]; // Take Selected file
    reader.readAsArrayBuffer(file); // Read the file

    // On File Load
    reader.onload = (e) => {
      file.url = e.target.result;
    };

    this.setState({ fileName: file.name });
    //this.props.autofill(typeindex,file.name);

    fileArr.push(file);
    this.setState({ fileArr: fileArr });
    this.props.change(this.props.pristine, false);
  }

  handleresolveandreopen = (values) => {
    let { user, singleReportdata } = this.props;
    let clientid = user.clientid;
    let singlereportid = singleReportdata[0].id;
    this.setState({ btncloseloading: true });

    let status = "open";
    if (values.status == "open") {
      status = "closed";
    }
    let obj = {
      id: values.id,
      status: status,
    };
    let emailobj = {};
    emailobj.id = values.id;
    emailobj.clientid = values.clientidfk;
    emailobj.type = "closeReportedissue";
    this.props.updateissueStatus(this.props.session, obj, (response) => {
      if (response.success === 0) {
        this.setState({ btncloseloading: false });
        this.props.showError(COMMON_FAIL_MESSAGE);
      } else {
        this.props.fetchsingleReport(
          this.props.session,
          singlereportid,
          (callback) => {
            this.setState({ btncloseloading: false });
            this.setState({ replybox: false });
            this.props.onClose();
            this.props.showSuccess("Successfully Updated");
          }
        );
        this.props.fetchadminissueTokenOpen(
          this.props.session,
          clientid,
          (CallBackResponse) => {
            this.props.fetchadminissueTokenClose(
              this.props.session,
              clientid,
              (CallBackResponse) => {}
            );
          }
        );
        if (values.status == "open") {
          this.props.closeIssueemail(this.props.session, emailobj);
        }
      }
    });
  };

  renderLoader = () => {
    return (
      <Loader type="line-scale-pulse-out-rapid" active className="loader-div" />
    );
  };

  render() {
    let { data, handleSubmit, singleReportdata, getFormValues, initialValues } =
      this.props;
    let { btncloseloading, replybox, btndisabled } = this.state;
    var fileStyle = {
      paddingRight: "10px",
      marginRight: "10px",
      border: "1px solid #e6edf3",
      padding: "10px",
      background: "#fff",
      width: "100%",
    };
    let singletokenno = "";
    let singleeventname = "";
    let singleeventid = "";
    let subject = "";

    if (singleReportdata && singleReportdata.length > 0) {
      singletokenno = singleReportdata[0].tokenno;
      singleeventname = singleReportdata[0].eventname;
      singleeventid = singleReportdata[0].eventid;
      if (
        singleReportdata[0].support_ticket_messages_by_reportissueidfk &&
        singleReportdata[0].support_ticket_messages_by_reportissueidfk.length >
          0
      ) {
        subject =
          singleReportdata[0].support_ticket_messages_by_reportissueidfk[0]
            .subject;
      }
    }
    return (
      <Modal
        show={this.props.isOpen}
        onHide={this.closeModals}
        className=""
        dialogClassName="contact-eventify-modal">
        <Modal.Header className="report-modalhead">
          <div className="row">
            <div className="title-modal col-md-6">#Ticket{singletokenno}</div>
            {singleeventname != null &&
            singleeventname != "" &&
            singleeventid != null &&
            singleeventid != "" ? (
              <>
                <div className="">
                  {LocaleStrings.accountsetting_reportissuemodal_eventname}
                  {singleeventname}
                </div>
                <div className="d-flex">
                  <div>{singleeventid}</div>{" "}
                </div>
              </>
            ) : (
              ""
            )}
          </div>
          <button
            type="button"
            className="i-custom-cross-popup pull-right"
            onClick={this.closeModals}>
            <img
              className="i-custom-small"
              src="../../style/images/custom-icons/cross-black.png"
            />
          </button>
        </Modal.Header>
        <form onSubmit={handleSubmit(this.onSubmitForm)}>
          <Modal.Body>
            {this.state.loading ? (
              <div className="loader-container">
                {this.renderLoader()}
                <div className="loader-info">{this.state.desc}</div>
              </div>
            ) : (
              <>
                {singleReportdata && singleReportdata.length > 0 ? (
                  <>
                    <div className="d-flex mb-20">
                      <div className="block reportmodal-top">
                        <div className="d-flex mb-2">
                          <div className="fw-bold">
                            {
                              LocaleStrings.accountsetting_reportissuemodal_subject
                            }
                          </div>
                          <div className="fw-bold ml-2"> {subject}</div>
                        </div>
                        <div className="d-flex mb-2">
                          <div className="fw-bold ">
                            {
                              LocaleStrings.accountsetting_reportissuemodal_issuereportedon
                            }
                          </div>
                          <div className="fw-bold  ml-2">
                            {singleReportdata[0]?.platform == "ios"
                              ? "IOS"
                              : singleReportdata[0]?.platform == "android"
                              ? "Android"
                              : singleReportdata[0]?.platform == "webapp"
                              ? "Web App"
                              : singleReportdata[0]?.platform == "adminpanel"
                              ? "Admin Panel"
                              : ""}
                          </div>
                        </div>
                        <div className="d-flex mb-20">
                          <div className="fw-bold ">
                            {
                              LocaleStrings.accountsetting_reportissuemodal_issuereportedby
                            }
                          </div>
                          <div className="fw-bold  ml-2">
                            {
                              singleReportdata[0]?.clients_by_clientidfk
                                ?.firstname
                            }{" "}
                            {
                              singleReportdata[0]?.clients_by_clientidfk
                                ?.lastname
                            }
                          </div>
                        </div>
                      </div>
                      {singleReportdata[0]?.status == "open" ? (
                        <div className="" style={{ marginLeft: "auto" }}>
                          <Button
                            className="btn btn-primary ml-2"
                            type="button"
                            onClick={() =>
                              this.handleresolveandreopen(singleReportdata[0])
                            }
                            loading={btncloseloading}>
                            {
                              LocaleStrings.accountsetting_reportissuemodal_closeissue_btn
                            }
                          </Button>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* {replybox == true ? (
                                            <> */}
                    <div className="reply-box">
                      <div className="mt-2">
                        <Field
                          name="description"
                          label={
                            Object.keys(initialValues).length > 0
                              ? "Reply(Draft)"
                              : "Reply"
                          }
                          component={this.renderFieldTextarea}
                          labelposition={LABEL_POSITION_TOP}
                          // onBlur={(e) => this.handleDraft(e)}

                          // component={this.renderFieldTextarea1}
                          mandatory="true"
                        />
                      </div>
                      <div className="mb-10">
                        <div className="" style={{ display: "flex" }}>
                          <span
                            className="text-sm "
                            style={{ color: "#000", width: "100%" }}>
                            {_.size(this.state.fileArr) > 0 ? (
                              <div style={{ marginTop: "10px" }}>
                                <p>
                                  {
                                    LocaleStrings.accountsetting_reportissuemodal_uploadfiles
                                  }
                                  <span style={{ color: "#2776EA" }}>
                                    {
                                      LocaleStrings.accountsetting_reportissuemodal_max5files
                                    }
                                  </span>
                                </p>
                                {_.map(this.state.fileArr, (value, index) => {
                                  return (
                                    <div
                                      style={{
                                        display: "flex",
                                        marginTop: "10px",
                                      }}>
                                      <div
                                        className="user-attachments"
                                        style={fileStyle}>
                                        {value.name}
                                      </div>

                                      <button
                                        className={classNames(
                                          _.size(this.state.fileArr) > 0
                                            ? "i-custom-table-delete "
                                            : "hidden i-custom-table-delete"
                                        )}
                                        style={{ marginTop: "5px" }}
                                        type="button"
                                        onClick={(e) =>
                                          this._handleUnSelect(e, index)
                                        }>
                                        <img
                                          className={classNames(
                                            _.size(this.state.fileArr) > 0
                                              ? "i-custom-table"
                                              : "hidden i-custom-table",
                                            "h-4 w-4  cursor-pointer"
                                          )}
                                          src="../../style/images/custom-icons/shape-1317-copy-3.svg"
                                        />
                                      </button>
                                    </div>
                                  );
                                })}
                              </div>
                            ) : (
                              ""
                            )}
                          </span>
                        </div>

                        <div
                          className="d-flex"
                          style={{
                            textAlign: "end",
                            cursor: "pointer",
                            marginTop: "5px",
                          }}>
                          <div>
                            {_.size(this.state.fileArr) < 5 ? (
                              <label
                                htmlFor="attachment"
                                className="relative cursor-pointer user-attachments"
                                style={{
                                  border: "1px solid #e6edf3",
                                  padding: "10px",
                                  background: "#fff",
                                  cursor: "pointer",
                                }}>
                                <span className="font-icomoon i-custom-ms">
                                  {AppIcons.uploadericon}
                                </span>
                                <span>{LocaleStrings.attach_files}</span>
                                <input
                                  id="attachment"
                                  name="attachment"
                                  type="file"
                                  // accept="image/*"
                                  className="sr-only"
                                  onChange={(e) => this._handleSelect(e)}
                                />
                              </label>
                            ) : (
                              ""
                            )}
                          </div>
                          <div style={{ marginLeft: "auto" }}>
                            <Button
                              className="btn-custom-blue"
                              loading={this.state.btnLoading}
                              type="submit"
                              disabled={btndisabled}
                              style={{
                                marginLeft: "10px",
                                marginRight: "10px",
                                width: "200px",
                              }}>
                              {singleReportdata[0]?.status == "open"
                                ? "Send"
                                : "Send and Reopen Issue"}
                            </Button>
                            {singleReportdata[0].status == "open" ? (
                              <Button
                                className="btn-custom-blue"
                                loading={this.state.btnsendcloseLoading}
                                type="button"
                                onClick={(e) => this._handlsendClose(e)}
                                disabled={this.state.btnsendclosedisabled}
                                style={{
                                  marginLeft: "10px",
                                  marginRight: "10px",
                                }}>
                                {
                                  LocaleStrings.accountsetting_reportissuemodal_sendclose_btn
                                }
                              </Button>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {singleReportdata[0]
                      ?.support_ticket_messages_by_reportissueidfk &&
                    singleReportdata[0]
                      ?.support_ticket_messages_by_reportissueidfk.length >
                      0 ? (
                      <span className=""> {this.renderList()}</span>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  ""
                )}
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <div>
              <div className="pull-left h-100 vertical-align-center"></div>
              <div
                className="pull-right h-100 vertical-align-center"
                style={{ marginLeft: "auto" }}></div>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

function validate(values) {
  // console.log('values',values);
  var errors = {};
  var requiredFields = ["description"];
  requiredFields.forEach((field) => {
    if (!values[field] || values[field].trim() === "") {
      errors[field] = "Required";
    }
  });
  return errors;
}

function mapStateToProps(state, ownProps) {
  let sortedDesc1 = [];

  if (
    state.singleReportdata &&
    state.singleReportdata?.data &&
    state.singleReportdata?.data.length > 0
  ) {
    sortedDesc1 = _.filter(
      state.singleReportdata?.data[0]
        ?.support_ticket_messages_by_reportissueidfk,
      (obj, index) => {
        return obj.isdraft == true && obj.repliedby !== null;
      }
    );
  }
  return {
    session: state.session,
    user: state.user,
    data: ownProps.data,
    singleReportdata: !_.isEmpty(state.singleReportdata)
      ? state.singleReportdata.data
      : [],
    initialValues: !_.isEmpty(sortedDesc1) ? sortedDesc1[0] : {},
    formValues: getFormValues("ReportIssueModalForm")(state),
  };
}
export default connect(mapStateToProps, {
  uploadreportedAttachments,
  addReports_tracker,
  fetchadminissueTokenOpen,
  fetchadminissueTokenClose,
  updateissueStatus,
  fetchsingleReport,
  updateReports_tracker,
  sendnewsupportTicketetointernal,
  closeIssueemail,
  showError,
  showSuccess,
})(
  reduxForm({
    validate,
    form: "ReportIssueModalForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(ReportIssueModal)
);
